import { Card } from "antd";

import { DeficientProjects } from "projects/components";
import { IDeficientProject } from "projects/models";

type Props = {
  loading?: boolean;
  deficientProjects?: IDeficientProject[];
};

export const ContractorDashboardDeficientProjectsCard = ({
  loading,
  deficientProjects,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='contractorDashboardDeficientProjectsCard'
    >
      <DeficientProjects deficientProjects={deficientProjects ?? []} />
    </Card>
  );
};
